import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import Loader from './components/Loader';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Training from './pages/Training';
import Warehousing from './pages/Warehousing';
import Transit from './pages/Transit';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Admin from './pages/Admin';
import Provider from './pages/Provider';
import StockInventory from './pages/StockInventory';
import './App.css';

const NO_FOOTER_ROUTES = ['/admin', '/provider', '/stock-inventory'];
const NO_NAVBAR_ROUTES = ['/stock-inventory'];

function Layout() {
    const { pathname } = useLocation();
    const { loading: authLoading } = useAuth();
    const showFooter = !NO_FOOTER_ROUTES.includes(pathname);
    const showNavbar = !NO_NAVBAR_ROUTES.includes(pathname);

    if (authLoading) {
        return <Loader fullscreen logo label="Loading ElecSolution" />;
    }

    return (
        <div className="App">
            {showNavbar && <Navbar />}
            <motion.main
                key={pathname}
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            >
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/training" element={<Training />} />
                    <Route path="/warehousing" element={<Warehousing />} />
                    <Route path="/transit" element={<Transit />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/provider" element={<Provider />} />
                    <Route path="/stock-inventory" element={<StockInventory />} />
                </Routes>
            </motion.main>
            {showFooter && <Footer />}
            <ScrollToTopButton />
        </div>
    );
}

function App() {
    const [appLoading, setAppLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setAppLoading(false), 1500);
        return () => clearTimeout(timer);
    }, []);

    if (appLoading) {
        return <Loader fullscreen logo label="Loading ElecSolution" />;
    }

    return (
        <AuthProvider>
            <Router>
                <ScrollToTop />
                <Layout />
            </Router>
        </AuthProvider>
    );
}

export default App;
